 <div class="loader" *ngIf="baseService.showRootLoader">
  <i class="fa fa-circle-o-notch fa-spin"></i>
</div>
<!--<nav class="navbar navbar-default navbar-fixed-top" *ngIf="isUserLoggedIn"
  [ngClass]="currentLocation==='/home'?'auto-height':'navbar-fixed-top'">
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
        aria-expanded="false" aria-controls="navbar">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand brand-logo" routerLink="home">
        <img [src]="'assets/images/ARA-Petroleum.png'" alt="ARA LOGO" />
      </a>
    </div>
    <div id="navbar" class="navbar-collapse collapse">
      <ara-side-nav [routesFlag]='baseService.routesFlag' [reportRoutes]='baseService.reportRoutes' *ngIf="!hideRoutes">
      </ara-side-nav>
      <div class="nav navbar-nav navbar-right navbar-right-container">
        <ara-faq class="faq-container"></ara-faq>
        <div>
          <strong>Welcome, </strong>
          <span class="current">{{loggedInUser?.FullName}}</span>
          <span *ngIf="loggedinUserType == 'Contractor'" class="ellepsis" popover="Change Password"
            popoverPlacement="bottom" [popoverOnHover]="true" [popoverCloseOnClickOutside]="true"
            [popoverCloseOnMouseOutside]="false" [popoverDisabled]="false" [popoverAnimation]="true"
            [popoverDismissTimeout]="0">
            <a class="color-white" (click)="changePass()"><i class="fa fa-key navbar-fa" aria-hidden="true"></i></a>
          </span>
          <span class="ellepsis padding-left-5" popover="Fix login issue" popoverPlacement="bottom" [popoverOnHover]="true"
            [popoverCloseOnClickOutside]="true" [popoverCloseOnMouseOutside]="false" [popoverDisabled]="false"
            [popoverAnimation]="true" [popoverDismissTimeout]="0">
            <a class="color-white" (click)="fixLoginIssue()"><i class="fa fa-wrench navbar-fa" aria-hidden="true"></i></a>
          </span>
          <span class="ellepsis padding-left-5" popover="LogOut" popoverPlacement="bottom" [popoverOnHover]="true"
            [popoverCloseOnClickOutside]="true" [popoverCloseOnMouseOutside]="false" [popoverDisabled]="false"
            [popoverAnimation]="true" [popoverDismissTimeout]="0">
            <a class="color-white" (click)="logout()"><i class="fa fa-sign-out navbar-fa" aria-hidden="true"></i></a>
          </span>
        </div>
      </div>
    </div>
  </div>
</nav> -->

<!-- Profile Info and Notifications -->
<div class="col-md-6 col-sm-8 clearfix" *ngIf="isUserLoggedIn">
		
    

      
    
</div>
<!-- <table>
  <tr>
    <td>
      <div class="col-md-6 col-sm-4 clearfix " *ngIf="isUserLoggedIn">
      <img src="assets/images/Mfanologo.png" width="120" alt="" />
      </div>
    </td>
    <td>
      <div class="col-md-6 col-sm-4 clearfix " *ngIf="isUserLoggedIn">
        <img src="assets/images/Mfanologo.png" width="120" alt="" />
        </div>
    </td>
  </tr>
</table> -->
<div class="clearfix"></div>
<div class="col-md-6 col-sm-4 clearfix "  *ngIf="isUserLoggedIn">
  <a [routerLink]="['/']">
  <img src="{{logoSrc}}" id="second-logo" width="120" alt="" style="margin-top:11px;" />
  </a>
</div>

<!-- Raw Links -->
<div class="col-md-6 col-sm-4 clearfix " *ngIf="isUserLoggedIn">

  <ul class="list-inline links-list pull-right">

    <li class="notifications dropdown" style="display:none;">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true"> <i class="entypo-bell"></i> <span class="badge badge-info">4</span> </a> <ul class="dropdown-menu pull-right">
          <li class="top">
              <p class="small">
                  <a href="#" class="pull-right">Mark all Read</a>
                  You have <strong>4</strong> new notifications.
              </p>
          </li>
          <li>
              <ul class="dropdown-menu-list scroller" tabindex="5001" style="overflow: hidden; outline: none;">
                  <li class="unread notification-success">
                      <a href="#">
                          <i class="entypo-user-add pull-right"></i> <span class="line"> <strong>New user registered</strong> </span> <span class="line small">
                              30 seconds ago
                          </span>
                      </a>
                  </li>
                  <li class="unread notification-secondary">
                      <a href="#">
                          <i class="entypo-heart pull-right"></i> <span class="line"> <strong>2 New Safety Observation Found</strong> </span> <span class="line small">
                              2 minutes ago
                          </span>
                      </a>
                  </li>
                  <li class="unread notification-secondary">
                      <a href="#">
                          <i class="entypo-cancel-circled pull-right"></i> <span class="line"> <strong>1 Incident Registered</strong> </span> <span class="line small">
                              10 minutes ago
                          </span>
                      </a>
                  </li>



              </ul>
          </li>
          <li class="external"> <a style="color: #ffffff">View all notifications</a> </li>
          <div id="ascrail2001" class="nicescroll-rails" style="padding-right: 3px; width: 10px; z-index: 1000; cursor: default; position: absolute; top: 0px; left: -10px; height: 0px; display: none;"><div style="position: relative; top: 0px; float: right; width: 5px; height: 0px; background-color: rgb(212, 212, 212); border: 1px solid rgb(204, 204, 204); background-clip: padding-box; border-radius: 1px;"></div></div>
          <div id="ascrail2001-hr" class="nicescroll-rails" style="height: 7px; z-index: 1000; top: -7px; left: 0px; position: absolute; cursor: default; display: none;"><div style="position: relative; top: 0px; height: 5px; width: 0px; background-color: rgb(212, 212, 212); border: 1px solid rgb(204, 204, 204); background-clip: padding-box; border-radius: 1px;"></div></div>
      </ul>
  </li>
<!-- Language Selector -->
    <li class="dropdown language-selector">

      
      <span>Welcome, </span>
      <strong>{{loggedInUser?.FullName}}</strong>
      <a href="#" class="dropdown-toggle" data-toggle="dropdown" data-close-others="true">
        <img src="{{profileImage}}" width="30" alt="" class="img-circle" />
      </a>

      <ul class="dropdown-menu pull-right">
        <!-- <li>
          <a href="#">
          <i class="entypo-user"></i>
            <span>Profile</span>
          </a>
        </li> -->
        <li *ngIf="loggedinUserType == 'Contractor'">
        <a class="color-white" (click)="changePass()" style="cursor: pointer;">
          <i class="fa fa-key navbar-fa" aria-hidden="true"></i>Change Password</a>
      </li>


        <li>
          <a (click)="logout()" class="color-white" style="cursor: pointer;">
            <i class="entypo-lock"  aria-hidden="true" ></i>
            Log Out
          </a>
        </li>
        </ul>

    </li>


    
  </ul>

</div>